import createIconSetFromFontello from "@react-native-vector-icons/fontello";
import fontelloConfig from "./icon-font.json";

const Icon = createIconSetFromFontello(
	fontelloConfig,
	"memorangicons",
	"memorangicons.ttf",
);
export default Icon;
